module.exports = __webpack_public_path__ + "static/media/puzzle-typography.fbd81153.jpeg";